// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_2FXjtvVfrcMhMvR-PrhBp0","spaceLeft":"tpax0gnqhEj3wgcu_o_d8","spaceBoth":"_28VtRj_6osPPJ0TlWa9vWx","spaceRight":"_2sfcSWC9g_orVcxcLwkEKN"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisOfferMakeForm.scss
// module id = 1258
// module chunks = 0